import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const TabsButton = styled.div<{ active: boolean }>`
  border: ${(props) => (props.active ? '1px solid #131717;' : 'none')};
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* margin-right: 32px; */
  margin-bottom: 24px;
  background-color: transparent;
  border-radius: 200px;
  cursor: pointer;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  line-height: normal;
  white-space: nowrap;

  ${down('md')} {
    height: 39px;
    margin-right: 5px;
    margin-bottom: 20px;
  }
`

export const TravelRoutesList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const TravelRoutesLink = styled.a`
  :hover {
    text-decoration: underline;
  }
`

export const Ul = styled.ul`
  padding-inline-start: 0px;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  /* padding: 0px 40px 0px 0px; */
  li::before {
    content: '•';
    margin-right: 0.5em;
    margin-left: 0.5rem;
    font-size: 0.9em;
  }
  li {
    color: #131717;
    font-size: 14px;
    margin-bottom: 16px;
    ${down('md')} {
      margin: 6px 0;
      margin-bottom: 12px;
    }
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: inline-flex;
  }

  [dir='rtl'] && {
    text-align: right;
  }
`

export const TravelRoutesHeading = styled.div`
  color: #131717;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
  ${down('md')} {
    margin-bottom: 16px;
    font-size: 20px;
  }
`

export const TravelRoutesContainer = styled.div`
  display: flex;
  margin: 60px auto;
  flex-direction: column;
  ${down('md')} {
    margin: 20px auto;
  }
`
